import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';

import { camelCaseToCapitalizedWords } from 'src/lib/formatters';

interface PartnerFeaturesProps {
    handlePermissionsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    permissions: object;
    editUserRoleDetails: boolean;
}

const UserRoleDetails = ({
    handlePermissionsChange,
    permissions,
    editUserRoleDetails,
}: PartnerFeaturesProps) => {
    const permissionLabels = Object.entries(permissions).map(([key, value]) => (
        <Grid item xs={12} sm={3} key={key}>
            <FormControlLabel
                control={<Checkbox checked={value} onChange={handlePermissionsChange} name={key} />}
                label={camelCaseToCapitalizedWords(key)}
            />
        </Grid>
    ));

    return (
        <Grid container>
            <Grid item container>
                {/**sub-heading section */}
                <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item md={6} xs={12}>
                        <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B' }}>
                            User Role Features
                        </Typography>
                        <Typography>
                            {!editUserRoleDetails
                                ? ''
                                : 'Set features to relate to your new user role'}
                        </Typography>
                    </Grid>
                </Grid>

                {/**permission items section */}
                <Grid item marginTop="35px" display="flex" flexWrap="wrap">
                    <Grid container spacing={2}>
                        {/**checkbox in four columns for permission items */}
                        {editUserRoleDetails
                            ? permissionLabels
                            : Object.entries(permissions).map(([key, value]) => (
                                  <Grid item xs={12} sm={3} key={key}>
                                      <FormControlLabel
                                          control={
                                              <Checkbox
                                                  name={key}
                                                  checked={value}
                                                  disabled={value === false}
                                              />
                                          }
                                          label={camelCaseToCapitalizedWords(key)}
                                      />
                                  </Grid>
                              ))}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UserRoleDetails;
